/**
 * Formats a date value according to the provided options
 * @param value - The date value to format
 * @param withTime - If true, includes time in the output. If string, appends time to the value
 * @param emptyIfError - If true, returns empty string on error
 * @param infinityChar - Character to display for infinity dates (2999)
 * @param locale - The locale to use for formatting (defaults to the current locale from LOCALE_ID)
 * @returns The formatted date string
 */

import { LOCALE_ID } from '@angular/core';

import { injectRoot } from '../inject';

// oxlint-disable-next-line max-params
const formatDate = (
  value?: string | Date | Temporal.PlainDate | Temporal.PlainDateTime | null,
  withTime?: string | true,
  emptyIfError = false,
  infinityChar = '–',
  locale = injectRoot(LOCALE_ID),
): string => {
  if (!value) {
    return '';
  }

  if (typeof withTime === 'string' && typeof value === 'string') {
    // eslint-disable-next-line no-param-reassign
    value += `T${withTime}`;
  }

  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',

    ...(withTime && { hour: 'numeric', minute: 'numeric', second: 'numeric' }),
  };

  try {
    // oxlint-disable-next-line new-cap
    const date = Intl.DateTimeFormat(locale, options).format(
      new Date(value.toString()),
    );

    return date.includes('2999') ? infinityChar : date;
  } catch {
    return emptyIfError ? '' : value.toString();
  }
};

export { formatDate };
